import BackToTopButton from 'syf-component-library/ui/atoms/BackToTopButton'
import styled from 'styled-components'
import query from 'mediaQueries'

const BackToTop = styled(BackToTopButton)`
  position: fixed;
  bottom: 25%;
  right: 0;
  cursor: pointer;
  @media ${query.greaterThanMedium} {
    right: 14%;
  }
`

export default BackToTop
